import {
    useWindowDimensions,
    View
} from "react-native";
import type WelcomeSectionProps from "./type";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    Avatar,
    Text
} from "ncore-ui-kit";
import InstallPwa from "../../../../components/installPwa";

const WelcomeSection = ({
    activeOrganizationId,
    activeOrgLogo,
    activeOrgName,
    displayName,
    isGuest
}: WelcomeSectionProps) => {
    const {
        width
    } = useWindowDimensions();
    const isMobile = width < 768;

    const {
        localize
    } = NCoreUIKitLocalize.useContext();

    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const welcomeTitle = isGuest ?
        localize("dashboard-guest-welcome")
    :
        localize("dashboard-welcome", [
            displayName || localize("user")
        ]);

    return <View
        style={[
            stylesheet.container,
            {
                backgroundColor: colors.project.brandWhite,
                borderRadius: radiuses.md,
                padding: spaces.spacingLg,
                gap: spaces.spacingLg
            }
        ]}
    >
        <View
            style={[
                stylesheet.userInfoContainer,
                {
                    gap: spaces.spacingMd
                }
            ]}
        >
            {
                activeOrganizationId && activeOrgName ?
                    <Avatar
                        imageUrl={activeOrgLogo}
                        title={activeOrgName}
                        size="medium"
                    />
                :
                    null
            }
            <View
                style={stylesheet.textContainer}
            >
                <Text
                    style={stylesheet.unselectableText}
                    variant="titleLargeSize"
                >
                    {welcomeTitle}
                </Text>
                <Text
                    variant="bodyMediumSize"
                    color="low"
                >
                    {localize("dashboard-overview-subtitle")}
                </Text>
            </View>
        </View>
        <View
            style={[
                stylesheet.pwaContainer,
                {
                    width: isMobile ? "100%" : "auto"
                }
            ]}
        >
            <InstallPwa
                spreadBehaviour={isMobile ? "stretch" : "free"}
            />
        </View>
    </View>;
};
export default WelcomeSection;
